import React, {createContext, useContext, useReducer, useMemo} from 'react';
import {SBLDashboardReducer} from "../reducer/SBLDashboardReducer";
import {DEFAULT_SORT_COLUMN, ASCENDING, DEFAULT_PERCENTILE} from "../../../util/Constants";

const SBLDashboardContext = createContext(null);

const INITIAL_STATE = {
    resourceDynamicAttributes: [],
    loading: true,
    sortPref: {column: DEFAULT_SORT_COLUMN, direction: ASCENDING},
    percentileThreshold: DEFAULT_PERCENTILE,
    error: null
};

export function useSBLDashboard() {
    const context = useContext(SBLDashboardContext);
    if (!context) {
        throw new Error("useSBLDashboard must be used within SBLDashboardContextProvider");
    }
    return context;
}

const SBLDashboardContextProvider = (props) => {
    const [viewModel, dispatch] = useReducer(SBLDashboardReducer, INITIAL_STATE);
    const value = useMemo(() => ({viewModel, dispatch}), [viewModel, dispatch]);

    return (
        <SBLDashboardContext.Provider value={value}>
            {props.children}
        </SBLDashboardContext.Provider>
    );
};

export default SBLDashboardContextProvider;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/context/SBLDashboardContext.js